import styled from 'styled-components';

import KeyFeatures from 'components/KeyFeatures';
import ImageCarousel from 'components/ImageCarousel';
import BookingCTA from 'components/BookingCTA';
import Hero from './Hero';
import Description from './Description';
import Location from '../LandingPage/Location';
import LocationCardSection from '../LocationCardSection/LocationCardSection';

import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';

const Section = styled.section`
  background-color: ${({ bgColor }) => bgColor};
`;

const StyledKeyFeaturesSection = styled(KeyFeatures)`
  background-color: ${COLORS.forest};
  padding: 72px 0;

  ${BREAKPOINTS.small`
    padding: 106px 0 132px;
  `}
`;

const StyledImageCarousel = styled(ImageCarousel)`
  padding: 72px 0;

  ${BREAKPOINTS.small`
    padding: 87px 0 65px;
  `}
`;

const XPage = ({ page, venues }) => {
  return (
    <>
      <Hero page={page} />

      {page.introSummaryOne && page.introSummaryTwo && (
        <Section bgColor={COLORS.pinkMillennial.opacity(0.7)}>
          <Description
            descriptionOne={page.introSummaryOne}
            descriptionTwo={page.introSummaryTwo}
            color={COLORS.purpleDark}
            ctaLink={page.introCtaLink}
            ctaLabel={page.introCtaLabel}
          />
        </Section>
      )}

      {page.keyFeatures.length > 0 && (
        <StyledKeyFeaturesSection
          title={page.keyFeaturesTitle}
          items={page.keyFeatures}
        />
      )}

      {page.imageCarousel.length > 0 && (
        <StyledImageCarousel
          images={page.imageCarousel}
          title={page.imageCarouselTitle}
        />
      )}

      {page.locationDetails ? (
        <Location title={'Finding us'} locationDetails={page.locationDetails} />
      ) : (
        <LocationCardSection heading={'Our locations'} venues={venues} />
      )}

      <BookingCTA
        bgColor={COLORS.sky}
        ctaLabel={page.ctaLabel}
        ctaLink={page.ctaLink}
      />
    </>
  );
};

export default XPage;
